export class FieldGroupDto {
  public customExportFieldGroupID: string;
  public dateField: string;
  public description: string;
  public jobIDField: string;
  public name: string;
  public viewName: string;
}
